import { warehouseService } from "../services";
import { warehouseConstants } from "../constants";
import { alertActions } from '.';

export const warehouseMasterActions = {
    getAll,
    createCompany,
    updateCompany,
    inActiveRow,
    getcmpnyddl,
    onHideShow,
    loadingData,
    onHideShowIsActive
};

function getAll(data) {
    return dispatch => {
        dispatch(request());

        warehouseService.fetchCompanyData(data).then(response => {
            dispatch(loadingData(false));
            dispatch(success(response.ResponseData))
        },
            error => {
                dispatch(loadingData(false));
                dispatch(failure(error.toString()));
                dispatch(alertActions.error(error.toString()));
            }
        );
    };

    function request() { return { type: warehouseConstants.GETALL_REQUEST } }
    function success(datas) { return { type: warehouseConstants.GETALL_SUCCESS, datas } }
    function failure(error) { return { type: warehouseConstants.GETALL_FAILURE, error } }
}

function createCompany(data) {
    return dispatch => {
        dispatch(request(data));

        warehouseService.createCompany(data).then(
            response => {
                //history.push('/');
                if (response && response.ResponseCode) {
                    if (response.ResponseCode === "200") {
                        dispatch(onHideShow(false));
                        if (response.ResponseData) {
                            dispatch(success(response.ResponseData));
                        }
                        dispatch(alertActions.success(response.ResponseMessage))
                    } else if (response.ResponseCode === "400") {
                        dispatch(alertActions.warning(response.ResponseMessage))
                    } else {
                        dispatch(alertActions.error(response.ResponseMessage))
                    }
                }
            },
            error => {
                dispatch(failure(error.toString()));
                dispatch(alertActions.error(error.toString()));
            }
        );
    };

    function request(data) { return { type: warehouseConstants.CREATE_REQUEST, data } }
    function success(data) { return { type: warehouseConstants.CREATE_SUCCESS, data } }
    function failure(error) { return { type: warehouseConstants.CREATE_FAILURE, error } }
};

function updateCompany(data) {
    return dispatch => {
        dispatch(request(data));

        warehouseService.updateCompany(data).then(
            response => {
                //history.push('/');                
                if (response && response.ResponseCode) {
                    if (response.ResponseCode === "200") {
                        dispatch(onHideShow(false));
                        dispatch(success(data));
                        dispatch(alertActions.success(response.ResponseMessage))
                    } else if (response.ResponseCode === "400") {
                        dispatch(alertActions.warning(response.ResponseMessage))
                    } else {
                        dispatch(alertActions.error(response.ResponseMessage))
                    }
                }
            },
            error => {
                dispatch(failure(error.toString()));
                dispatch(alertActions.error(error.toString()));
            }
        );
    };

    function request(data) { return { type: warehouseConstants.UPDATE_REQUEST, data } }
    function success(data) { return { type: warehouseConstants.UPDATE_SUCCESS, data } }
    function failure(error) { return { type: warehouseConstants.UPDATE_FAILURE, error } }
};


function inActiveRow(companyId, isActive) {
    var data = {
        CompanyId: companyId,
        IsActive: isActive
    }
    return dispatch => {
        dispatch(request());

        warehouseService.inActiveRow(companyId, isActive).then(
            response => {
                if (response && response.ResponseCode) {
                    if (response.ResponseCode === "200") {
                        dispatch(success(data));
                        dispatch(onHideShowIsActive(false));
                        dispatch(alertActions.success(response.ResponseMessage))
                    } else if (response.ResponseCode === "400") {
                        dispatch(alertActions.warning(response.ResponseMessage))
                    } else {
                        dispatch(alertActions.error(response.ResponseMessage))
                    }
                }
            },
            error => {
                dispatch(failure(error.toString()));
                dispatch(alertActions.error(error.toString()));
            }
        );
    };
    function request() { return { type: warehouseConstants.ISACTIVE_REQUEST } }
    function success(data) { return { type: warehouseConstants.ISACTIVE_SUCCESS, data } }
    function failure(error) { return { type: warehouseConstants.ISACTIVE_FAILURE, error } }
};

function getcmpnyddl() {
    return dispatch => {
        dispatch(request());

        warehouseService.FetchCompanyDDL().then(response => {
            dispatch(success(response.ResponseData))
        },
            error => {
                dispatch(failure(error.toString()));
                dispatch(alertActions.error(error.toString()));
            }
        );
    };

    function request() { return { type: warehouseConstants.GETCMPNYDDL_REQUEST } }
    function success(datas) { return { type: warehouseConstants.GETCMPNYDDL_SUCCESS, datas } }
    function failure(error) { return { type: warehouseConstants.GETCMPNYDDL_FAILURE, error } }
};

function onHideShow(isbool) {
    return {
        type: warehouseConstants.DIALOG_REQUEST, isbool
    }
}

function loadingData(isbool) {
    return {
        type: warehouseConstants.LOADING_REQUEST, isbool
    }
}

function onHideShowIsActive(isbool) {
    return {
        type: warehouseConstants.DIALOG_ISACTIVE_REQUEST, isbool
    }
}



